import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import CategoryLearnMore from "./CategoryLearnMore";
import LinkButtonSecondary from "./LinkButtonSecondary";
import ListingsBreadcrumb from "./ListingsBreadcrumb";
import PropTypes from "prop-types";
import React from "react";

function CategoriesNav({ brand, isLatestDrop, category }) {
  return (
    <Box
      bg={brand ? "grey" : isLatestDrop ? "white" : category.rootCategorySlug}
      pt={brand ? 0 : 60}
      mt={brand ? 0 : -60}
      borderBottom={!brand && isLatestDrop ? "1px solid black" : ""}
    >
      <BoxWithGutter pt={[42, null, 50, null]} pb={[50, null, 50, null]}>
        <ListingsBreadcrumb
          brand={brand}
          isLatestDrop={isLatestDrop}
          category={category}
        />

        {typeof category.children !== "undefined" &&
          category.children.length > 1 && (
            <Box
              display="flex"
              flexWrap="wrap"
              pt={[18, null, 28, null]}
              pb={10}
            >
              {category.children.map((child) => {
                const childHref = `/${child.slug}`;
                return (
                  <Box m="2px" key={child.slug}>
                    <LinkButtonSecondary
                      text={child.name}
                      href={childHref}
                      bg="black"
                      color="white"
                    />
                  </Box>
                );
              })}
            </Box>
          )}
        {category.readMore && <CategoryLearnMore content={category.readMore} />}
      </BoxWithGutter>
    </Box>
  );
}

export default CategoriesNav;

CategoriesNav.propTypes = {
  rootCategory: PropTypes.shape({
    title: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.object),
  }),
};
